import React from 'react';
import { ToastContainer, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './notification.css';
import CloseIcon from '../svg/close';
import { nombreEleccion } from '../../resources/constantes.json';
import styled from 'styled-components/macro';
import {
  getNotificationText,
  useDispatchNotifications,
  actionTypes,
} from '../../contexts/notificationsContext';
import { useTranslate } from '../../contexts/languageContext';
import { getUrl } from '../../utils';
import { Link } from 'react-router-dom';
import FlechaDerecha from '../../assets/img/FlechaDerecha.jsx';
import { responsive } from '../../resources/constantes.json';

/**
 * Notificacion que se muestra en pantalla cuando se recibe una notificación mediante
 * el archivo json de indicador de notificaciones. Presenta información sobre la elección
 * a la que corresponde la notificacion y un botón para ir a esa elección
 */

const NotificationContainer = props => {
  return (
    <StyledToastContainer
      transition={Zoom}
      position="bottom-right"
      autoClose={7000}
      hideProgressBar={false}
      closeOnClick={true}
      pauseOnHover={false}
      className="notification"
      bodyClassName="notification--body"
      progressClassName="notification--progres-bar"
      draggable={false}
      closeButton={<CloseButton />}
    />
  );
};
export const BodyNotificacion = ({ notification, nomenclator }) => {
  const { eleccion, mdhm } = notification;
  const t = useTranslate();
  const dispatch = useDispatchNotifications();
  const { title, subtitle } = getNotificationText({
    eleccion,
    tope: 0,
    mdhm,
    t,
  });



  const subtitlePased = subtitle.replaceAll(' ', '').split('-')
  const hora = subtitlePased[0];
  const fecha = subtitlePased[1];

  return (
    <StyledBoxLink
      css="display:block"
      to={getUrl({
        id: 0,
        eleccion,
        nomenclator,
        page: nombreEleccion[eleccion],
      })}
      onClick={() => dispatch({ type: actionTypes.read, id: notification.id })}
    >
      <TextoWrapper>
        <Texto>
          <div className="title"> {title}</div>
          <div className="subtitle"> <Hour>{hora}</Hour> <span>{fecha}</span></div>
        </Texto>
        <ArrowWrapper>
          <div
            style={{
              borderRadius: '100%',
              backgroundColor: '#215CCC',
              color: 'white',
              alignSelf: 'center',
              justifySelf: 'center',
              textAlign: 'center',
              height: '40px',
              width: '40px',
              marginTop: 'auto',
              marginBottom: 'auto',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignContent: 'center',
            }}
          >
            <FlechaDerecha style={{ margin: 'auto', height: '20px' }} />
          </div></ArrowWrapper>
      </TextoWrapper>

    </StyledBoxLink>
  );
};

const StyledToastContainer = styled(ToastContainer)`
  display:flex;
  flex-direction:column;
  gap:1rem;
  @media print {
    display: none;
  }
  @media screen and (max-width: ${responsive.maxWidth.mobile}px) {
    display: none;
  }
  `;

const StyledBoxLink = styled(Link)`
  &&:hover {
    text-decoration: none;
  }
  @media print {
    display: none;
  }
`;

const CloseButton = ({ closeToast }) => {
  return (
    <SCloseIcon
      width="14px"
      height="14px"
      fill="#215CCC"
      onClick={closeToast}
    />
  );
};

const SCloseIcon = styled(CloseIcon)`
  position: absolute;
  right: 10px;
  top: 10px;
`;

const TextoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 4rem;
  align-items: center;
`

const Texto = styled.div`
  color: #164192;
  display: block;
  padding: 10px;
  @media (max-width: 768px) {
    padding: 10px 20px 10px 10px;
  }
`;

const ArrowWrapper = styled.div``

const Hour = styled.span`
  color: #E40424;
`

export default NotificationContainer;
